<template>
  <settings-modal
    class="forex-currency-pair-delete-modal t-forex-currency-pair-delete-modal"
  >
    <span
      slot="heading"
      class="font-weight-bold"
    >Delete {{ currencyLimits.currency }} limits</span>

    <data-row class="mb-2">
      <v-flex>
        <one-data-column>
          <data-heading
            slot="label"
            heading="Day"
          />
        </one-data-column>

        <one-data-column
          :label-props="columnLabelProps"
          :data-props="columnDataProps"
        >
          <data-label slot="label">Operational limit</data-label>
          <div class="t-day-operational-limit">{{ formatCurrencyLimit(currencyLimits.dayOperationLimit) }}</div>
        </one-data-column>

        <one-data-column
          :label-props="columnLabelProps"
          :data-props="columnDataProps"
        >
          <data-label slot="label">Period limit</data-label>
          <div class="t-day-period-limit">{{ formatCurrencyLimit(currencyLimits.dayPeriodLimit) }}</div>
        </one-data-column>

        <one-data-column
          :label-props="columnLabelProps"
          :data-props="columnDataProps"
        >
          <data-label slot="label">Balance limit</data-label>
          <div class="t-day-balance-limit">{{ formatCurrencyLimit(currencyLimits.dayBalanceLimit) }}</div>
        </one-data-column>

        <one-data-column>
          <data-heading
            slot="label"
            heading="Night"
            spaced
          />
        </one-data-column>

        <one-data-column
          :label-props="columnLabelProps"
          :data-props="columnDataProps"
        >
          <data-label slot="label">Operational limit</data-label>
          <div class="t-night-operational-limit">{{ formatCurrencyLimit(currencyLimits.nightOperationLimit) }}</div>
        </one-data-column>

        <one-data-column
          :label-props="columnLabelProps"
          :data-props="columnDataProps"
        >
          <data-label slot="label">Period limit</data-label>
          <div class="t-night-period-limit">{{ formatCurrencyLimit(currencyLimits.nightPeriodLimit) }}</div>
        </one-data-column>

        <one-data-column
          :label-props="columnLabelProps"
          :data-props="columnDataProps"
        >
          <data-label slot="label">Balance limit</data-label>
          <div class="t-night-balance-limit">{{ formatCurrencyLimit(currencyLimits.nightBalanceLimit) }}</div>
        </one-data-column>

        <one-data-column>
          <data-heading
            slot="label"
            heading="Weekends"
            spaced
          />
        </one-data-column>

        <one-data-column
          :label-props="columnLabelProps"
          :data-props="columnDataProps"
        >
          <data-label slot="label">Operational limit</data-label>
          <div class="t-weekends-period-limit">{{ formatCurrencyLimit(currencyLimits.weekendOperationLimit) }}</div>
        </one-data-column>

        <one-data-column
          :label-props="columnLabelProps"
          :data-props="columnDataProps"
        >
          <data-label slot="label">Period limit</data-label>
          <div class="t-weekends-period-limit">{{ formatCurrencyLimit(currencyLimits.weekendPeriodLimit) }}</div>
        </one-data-column>

        <one-data-column
          :label-props="columnLabelProps"
          :data-props="columnDataProps"
        >
          <data-label slot="label">Balance limit</data-label>
          <div class="t-weekends-balance-limit">{{ formatCurrencyLimit(currencyLimits.weekendBalanceLimit) }}</div>
        </one-data-column>
      </v-flex>
    </data-row>

    <template slot="actions">
      <v-btn
        class="t-confirm-button"
        color="error"
        medium
        flat
        :disabled="loading"
        @click="onDeleteButtonClick"
      >delete limits</v-btn>

      <v-btn
        class="t-cancel-button"
        color="primary"
        medium
        flat
        @click="onCloseButtonClick"
      >cancel</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  // Events
  import { EVENT_FOREX_CURRENCY_LIMITS_CHANGE } from '@/events/forexCurrencyLimits'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import ProfileApi from '@/services/Api/ProfileApi'

  // Mixins
  import modal from '@/mixins/modal'
  import flashMessages from '@/mixins/flashMessages'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import DataHeading from '@/components/ui/Data/DataHeading'
  import DataRow from '../ui/Data/DataRow'
  import DataLabel from '@/components/ui/Data/DataLabel'
  import OneDataColumn from '@/components/ui/Data/OneDataColumn'

  export default {
    name: 'ProfileForexCurrencyLimitsDeleteModal',
    components: {
      SettingsModal,
      DataHeading,
      DataRow,
      DataLabel,
      OneDataColumn
    },
    mixins: [modal, flashMessages],
    data () {
      return {
        deleteCurrencyLimitsApiRequest: new ApiRequest(ProfileApi.deleteForexCurrencyLimits)
      }
    },
    computed: {
      currencyLimits () {
        return this.modalData.currencyLimits
      },
      columnLabelProps () {
        return { style: 'width: 150px;' }
      },
      columnDataProps () {
        return { style: 'min-width: auto;' }
      },
      loading () {
        return this.deleteCurrencyLimitsApiRequest.loading
      }
    },
    methods: {
      onDeleteButtonClick () {
        this.deleteCurrencyLimitsApiRequest
          .execute(this.modalData.profileId, this.currencyLimits.currency)
          .then(() => {
            this.$eventHub.$emit(EVENT_FOREX_CURRENCY_LIMITS_CHANGE)

            this.showSuccessFlashMessage('Limits have been successfully deleted.')
          })
          .catch(() => {
            this.showErrorFlashMessage('Limits have not been deleted.')
          })
      },
      onCloseButtonClick () {
        this.closeModal()
      },
      formatCurrencyLimit (limit) {
        return limit != null ? this.$options.filters.number(limit, 0) : 'Unlimited'
      }
    }
  }
</script>
